import FootballStatsCategory from "../../../../stats/football-stats-category";
import FootballState from "../../../../state/football-state";
import StatsRule from "../../../../../common/stats-rule";

/**
 * Stats rule for recording Bar Ball occurrences (Indoor Football).
 * Records attempted and recovery type (kicking/receiving team).
 */
export default class BarBallStats extends StatsRule {
    // eslint-disable-next-line no-unused-vars
    applicable(
        gameContext,
        ruleContext,
        eventConfiguration,
        { play, fragment }
    ) {
        return (
            FootballState.HitGoalpost === fragment.associatedState &&
            (play.historyContains(FootballState.BarBallRecoveredKicking) ||
                play.historyContains(FootballState.BarBallRecoveredReceiving) ||
                play.historyContains(FootballState.ReboundNetCaughtOffense) ||
                play.historyContains(FootballState.ReboundNetCaughtDefense) ||
                play.historyContains(FootballState.ReboundNetHitGround)) &&
            super.applicable(gameContext, ruleContext, eventConfiguration, {
                play,
                fragment
            })
        );
    }

    // eslint-disable-next-line no-unused-vars
    async apply(
        gameContext,
        ruleContext,
        eventConfiguration,
        { play, fragment }
    ) {
        const recoveredKickingFragment = play.getFirstFragment(
            FootballState.BarBallRecoveredKicking
        );
        const recoveredReceivingFragment = play.getFirstFragment(
            FootballState.BarBallRecoveredReceiving
        );
        const caughtOffenseFragment = play.getFirstFragment(
            FootballState.ReboundNetCaughtOffense
        );
        const caughtDefenseFragment = play.getFirstFragment(
            FootballState.ReboundNetCaughtDefense
        );
        const hitGroundFragment = play.getFirstFragment(
            FootballState.ReboundNetHitGround
        );

        // Get kicker info from Kick fragment
        const { kickedBy, id } =
            play.getFirstFragment(FootballState.Kick) || {};

        const stats = [];

        this.addStats(
            {
                gameId: play.gameId,
                playId: play.id,
                period: gameContext.currentPeriod,
                teamId: kickedBy?.teamId,
                playerId: kickedBy?.id,
                driveId: gameContext.currentDriveId,
                fragmentId: id,
                category: FootballStatsCategory.BAR_BALL,
                values: {
                    attempted: 1,
                    recoveredKicking: recoveredKickingFragment ? 1 : 0,
                    recoveredReceiving: recoveredReceivingFragment ? 1 : 0,
                    caughtOffense: caughtOffenseFragment ? 1 : 0,
                    caughtDefense: caughtDefenseFragment ? 1 : 0,
                    hitGround: hitGroundFragment ? 1 : 0
                }
            },
            stats
        );

        return stats;
    }
}
